import PropTypes from 'prop-types';
import WelcomeView from 'routes/Welcome/components/WelcomeView';

/**
 * Hero/Welcome del CMS legacy.
 * Mobile: full-bleed (comportamiento actual).
 * Tablet/Desktop: max-w-7xl mx-auto y rounded-xl para evitar full-width estirado.
 */
const WelcomeBlock = ({ value }) => (
  <section className='cms-block cms-block--welcome py-6 md:py-6 lg:py-8'>
    <div className='w-full lg:max-w-7xl mx-auto lg:rounded-xl lg:overflow-hidden'>
      <WelcomeView
        preTitle={value?.preTitle || ''}
        title={value?.title || ''}
        cards={(value?.cards || []).map((item) => ({
          id: item.id,
          ...item.value,
        }))}
        actions={(value?.actions || []).map((item) => ({
          id: item.id,
          ...item.value,
        }))}
      />
    </div>
  </section>
);

WelcomeBlock.propTypes = {
  value: PropTypes.shape({
    preTitle: PropTypes.string,
    title: PropTypes.string,
    cards: PropTypes.array,
    actions: PropTypes.array,
  }).isRequired,
};

export default WelcomeBlock;
